












import {Component} from "vue-property-decorator"
import BaseVue from "../../utils/BaseVue"
import logger from "../../utils/logging"
import router from "../../router"

@Component
export default class OidcCallbackPage extends BaseVue {

    private get isSuccessful() {
        // tslint:disable no-string-literal
        return !this.$route.meta["isOidcError"]
    }

    private async mounted() {
        if (this.isSuccessful) {
            const redirectPath = await this.$typedStore.actions.auth.oidcSignInCallback()
            logger.debug("[Auth] Sign in successful. Redirecting to: ", redirectPath)
            router.replace(redirectPath)
        } else {
            logger.debug("[Auth] Sign in failed.")
        }
    }
}
